import { useState } from 'react';
import "./Button.css";


function Button(params) {
   const [viewport, setViewport] = useState(document.documentElement.clientWidth);
   window.addEventListener('resize', () => {
      //  viewport = document.documentElement.clientWidth;
      setViewport(document.documentElement.clientWidth);
   });
   let buttonClasses = `store-button ${viewport >= 992 ? "desktop" : "mobile"}`;
   let textClases = `text ${viewport >= 992 ? "desktop" : "mobile"}`;
   let downloadClasses = `download ${viewport >= 992 ? "desktop" : "mobile"}`;
   let mobileIconClasses = `store-icon mobile ${viewport >= 992 ? "hidden" : ""}`;
   let iconClasses = `store-icon ${viewport >= 992 ? "" : "hidden"}`;
   let downloadTextClasses = `download-text ${viewport >= 992 ? "desktop" : "mobile"}`;
   let storeClases = `download-text store ${viewport >= 992 ? "desktop" : "mobile"}`;
   let qrClasses = `qr ${viewport >= 992 ? "desktop" : "mobile"}`;


   return <a className={buttonClasses} href={params.href} target= "_blank" rel= "noopener noreferrer" onContextMenu={(e) => e.preventDefault()} draggable="false" onDragStart={(e) => e.preventDefault()}>
      <img className={mobileIconClasses} src={params.icon} alt="" draggable="false" onDragStart={(e) => e.preventDefault()}/>
      <span className={textClases}>
         <span className={downloadClasses}>
            <img className={iconClasses} src={params.icon} alt="" onContextMenu={(e) => e.preventDefault()} draggable="false" onDragStart={(e) => e.preventDefault()}/>
            <span className={downloadTextClasses}>{params.accompanyingText}</span>
         </span>
         <span className={storeClases}>{params.storeName}</span>
      </span>
      <img className={qrClasses} src={params.qr} alt="" onContextMenu={(e) => e.preventDefault()} draggable="false" onDragStart={(e) => e.preventDefault()}/>

   </a>


}

export default Button;